import { Card, TextField, Typography, Box } from '@mui/material';
//const addressInputRowHeight = singleInputRowHeight * 6 + 10;

export const FormCategory = (props) => {
  const title = props.title;
  return (
    <Typography
      variant='subtitle2'
      // sx={{ height: singleInputRowHeight, margin: '2%', fontWeight: 'bold' }}
      sx={{ fontWeight: 'bold' }}
    >
      {title}
    </Typography>
  );
};
export const FormHeadCategory = (props) => {
  const title = props.title;
  return (
    <Typography
      variant='subtitle2'
      // sx={{ height: singleInputRowHeight, margin: '2%', fontWeight: 'bold' }}
      sx={{
        fontWeight: 'bold',
        fontSize: '1.2em',
        textDecoration: 'underline',
      }}
    >
      {title}
    </Typography>
  );
};
export const FormInfo = (props) => {
  const title = props.title;
  return (
    <Typography
      variant='body2'
      // sx={{ height: singleInputRowHeight, margin: '2%', fontWeight: 'bold' }}
    >
      {title}
    </Typography>
  );
};

export const FormCard = (props) => {
  const elements = props.elements;
  return (
    <Card sx={{ boxShadow: 'none', border: 'none', background: 'none' }}>
      {elements}
    </Card>
  );
};

export const FormTextInput = (props) => {
  const inputId = props.inputId;
  const inputDefault = props.inputDefault;
  const totalRows = props.totalRows;
  return (
    <TextField
      sx={{ width: '100%', background: '#ffffff' }}
      id={inputId}
      variant='standard'
      rows={totalRows}
      defaultValue={inputDefault}
      multiline
    />
  );
};
